import { snake } from 'change-case'
import { api } from '../../libs/api'

export default {
  namespaced: true,

  state: {
    downloading: false,
    query: {
      aggregationFromDate: '',
      aggregationToDate: '',
      salaryCd: '',
      rangeType: '',
      aggType: '',
      verticalAxis: '',
      prefectureCd: [],
      cityCd: [],
      employmentCd: [],
      jobtypeCd: [],
      industryCd: [],
      workPlacePrefectureCd: [],
      workPlaceCityCd: [],
      mediaCd: [],
      keyword: [],
      excludeKeyword: [],
      applyKeywordsToCatchcopy: 'true',
      applyKeywordsToJobtypeName: 'true',
      applyKeywordsToJobContents: 'true',
      applyKeywordsToQualification: 'true',
      applyKeywordsToCompanyName: 'true',
      applyExcludeKeywordsToCatchcopy: 'true',
      applyExcludeKeywordsToJobtypeName: 'true',
      applyExcludeKeywordsToJobContents: 'true',
      applyExcludeKeywordsToQualification: 'true',
      applyExcludeKeywordsToCompanyName: 'true',
    },
    index: {},
  },
  getters: {
    apiQuery: state =>
      ({
        aggregationFromDate: state.query.aggregationFromDate,
        aggregationToDate: state.query.aggregationToDate,
        salaryCd: state.query.salaryCd,
        rangeType: state.query.rangeType,
        aggType: state.query.aggType,
        verticalAxis: state.query.verticalAxis,
        prefectureCd: state.query.prefectureCd.map(p => (p.value || p)).join(','),
        cityCd: state.query.cityCd.map(p => (p.value || p)).join(','),
        employmentCd: state.query.employmentCd.map(ec => (ec.value || ec)).join(','),
        jobtypeCd: state.query.jobtypeCd.map(t => (t.value || t)).join(','),
        industryCd: state.query.industryCd.map(i => (i.value || i)).join(','),
        workPlacePrefectureCd: state.query.workPlacePrefectureCd.map(p => (p.value || p)).join(','),
        workPlaceCityCd: state.query.workPlaceCityCd.map(p => (p.value || p)).join(','),
        mediaCd: state.query.mediaCd.map(m => (m.value || m)).join(','),
        keyword: state.query.keyword.map(i => (i.value || i)).join(','),
        excludeKeyword: state.query.excludeKeyword.map(i => (i.value || i)).join(','),
        applyKeywordsToCatchcopy: state.query.applyKeywordsToCatchcopy,
        applyKeywordsToJobtypeName: state.query.applyKeywordsToJobtypeName,
        applyKeywordsToJobContents: state.query.applyKeywordsToJobContents,
        applyKeywordsToQualification: state.query.applyKeywordsToQualification,
        applyKeywordsToCompanyName: state.query.applyKeywordsToCompanyName,
        applyExcludeKeywordsToCatchcopy: state.query.applyExcludeKeywordsToCatchcopy,
        applyExcludeKeywordsToJobtypeName: state.query.applyExcludeKeywordsToJobtypeName,
        applyExcludeKeywordsToJobContents: state.query.applyExcludeKeywordsToJobContents,
        applyExcludeKeywordsToQualification: state.query.applyExcludeKeywordsToQualification,
        applyExcludeKeywordsToCompanyName: state.query.applyExcludeKeywordsToCompanyName,
      }),
  },
  mutations: {
    aggregationFromDate: (state, value) => state.query.aggregationFromDate = value,
    aggregationToDate: (state, value) => state.query.aggregationToDate = value,
    salaryCd: (state, value) => state.query.salaryCd = value,
    rangeType: (state, value) => state.query.rangeType = value,
    aggType: (state, value) => state.query.aggType = value,
    verticalAxis: (state, value) => state.query.verticalAxis = value,
    setAggregationJobs: (state, index) => state.index = index,
    prefectureCd: (state, value) => state.query.prefectureCd = value,
    cityCd: (state, value) => state.query.cityCd = value,
    employmentCd: (state, value) => state.query.employmentCd = value,
    jobtypeCd: (state, value) => state.query.jobtypeCd = value,
    industryCd: (state, value) => state.query.industryCd = value,
    workPlacePrefectureCd: (state, value) => state.query.workPlacePrefectureCd = value,
    workPlaceCityCd: (state, value) => state.query.workPlaceCityCd = value,
    mediaCd: (state, value) => state.query.mediaCd = value,
    keyword: (state, value) => state.query.keyword = value,
    excludeKeyword: (state, value) => state.query.excludeKeyword = value,
    applyKeywordsToCatchcopy: (state, value) => state.query.applyKeywordsToCatchcopy = value,
    applyKeywordsToJobtypeName: (state, value) => state.query.applyKeywordsToJobtypeName = value,
    applyKeywordsToJobContents: (state, value) => state.query.applyKeywordsToJobContents = value,
    applyKeywordsToQualification: (state, value) => state.query.applyKeywordsToQualification = value,
    applyKeywordsToCompanyName: (state, value) => state.query.applyKeywordsToCompanyName = value,
    applyExcludeKeywordsToCatchcopy: (state, value) => state.query.applyExcludeKeywordsToCatchcopy = value,
    applyExcludeKeywordsToJobtypeName: (state, value) => state.query.applyExcludeKeywordsToJobtypeName = value,
    applyExcludeKeywordsToJobContents: (state, value) => state.query.applyExcludeKeywordsToJobContents = value,
    applyExcludeKeywordsToQualification: (state, value) => state.query.applyExcludeKeywordsToQualification = value,
    applyExcludeKeywordsToCompanyName: (state, value) => state.query.applyExcludeKeywordsToCompanyName = value,
    addExcludeKeyword: (state, value) => {
      state.query.excludeKeyword.push(value)
    },
    addKeyword: (state, value) => {
      state.query.keyword.push(value)
    },
    removeExcludeKeyword: (state, index) => {
      state.query.excludeKeyword.splice(index, 1)
    },
    removeKeyword: (state, index) => {
      state.query.keyword.splice(index, 1)
    },
  },
  actions: {
    async fetchIndex ({ commit }, query) {
      try {
        const requestParameters = Object.keys(query).reduce((acc, key) => {
          acc[snake(key)] = query[key]
          return acc
        }, {})

        const index = await api.fetchAggregationJob(requestParameters)

        commit('setAggregationJobs', index)
      } catch (e) {
        return Promise.reject(e)
      }
    },
    downloadAggregationJobCsv ({ getters: { apiQuery } }, { allColumns }) {
      const requestParameters = Object.keys(apiQuery).reduce((acc, key) => {
        acc[snake(key)] = apiQuery[key]
        return acc
      }, {})
      return api.downloadAggregationJobCsv(requestParameters, allColumns)
    },
  },
  modules: {
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/aggregateJob.js